'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ManageLink.scss');

var ManageLink = (_dec = (0, _reactRedux.connect)(null, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ManageLink, _Component);

  function ManageLink() {
    (0, _classCallCheck3.default)(this, ManageLink);
    return (0, _possibleConstructorReturn3.default)(this, (ManageLink.__proto__ || (0, _getPrototypeOf2.default)(ManageLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(ManageLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          pushState = _props.pushState,
          isBack = _props.isBack,
          link = _props.link,
          text = _props.text,
          header = _props.header;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, styles.manageGroupsSection, (0, _defineProperty3.default)({}, styles.isBack, isBack)), onClick: function onClick() {
            return pushState(link);
          } },
        _react2.default.createElement(
          'h3',
          { className: 'margin-free' },
          header
        ),
        !!text && _react2.default.createElement(
          'div',
          { className: 'margin-top-10' },
          text
        ),
        _react2.default.createElement('i', { className: (0, _classnames2.default)(styles.arrow, isBack ? 'icon-chevron-thin-left' : 'icon-chevron-thin-right') })
      );
    }
  }]);
  return ManageLink;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  header: _propTypes2.default.string.isRequired,
  isBack: _propTypes2.default.bool,
  link: _propTypes2.default.string.isRequired,
  pushState: _propTypes2.default.func,
  text: _propTypes2.default.string
}, _temp)) || _class);
exports.default = ManageLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Contacts/ManageLink.js
// module id = 1977
// module chunks = 1